import React from 'react'
import { PriceExpressionValidator } from '../../../../components'
import { useTranslation } from 'react-i18next'
import { PriceModelAPI } from '../../../../api/Argentia/endpoints/pricing/model/prices'
import { PriceDetails } from '../../../pricing/pricing.Model'
import { FormSkeleton } from '@globaleris/ui.library'
import { Box, Card, CardContent, CardHeader, Paper, Typography } from '@material-ui/core'
import { EnumPriceType } from '../../../../api/oData/enums/enumPriceType'

interface FlexibilityPriceProps {
  price?: PriceDetails
  onChangeInput?: (input: string, value: any) => void
  onIsValid?: (isValid: boolean) => void
  onIsLoading?: (isLoading: boolean) => void
}

export const FlexibilityPrice: React.FC<FlexibilityPriceProps> = ({
  price,
  onChangeInput,
  onIsValid,
  onIsLoading
}) => {
  const [t] = useTranslation(['flexibilityAdd', 'globalerisLibrary', 'enums'])

  const EmptyPriceCard = () => {
    return (
      <Card>
        <CardHeader title={t('flexibilityAdd:forms.add.priceSectionTitle')}></CardHeader>
        <CardContent>La flexibilidad no tiene un precio asociado.</CardContent>
      </Card>
    )
  }

  if (price === undefined) {
    return <FormSkeleton columns={3} inputs={6} />
  }

  return (
    <Box marginY={2}>
      <Paper elevation={3}>
        {price === null ? (
          <EmptyPriceCard />
        ) : (
          <PriceExpressionValidator
            readOnly={price === null}
            elevation={0}
            showPriceUnit
            showVersion
            showRounding
            title={t('flexibilityAdd:forms.add.priceSectionTitle')}
            priceType={EnumPriceType.Formula}
            commodity={price.commodity!}
            onIsValid={isValid => {
              onIsValid && onIsValid(isValid)
              // setExpressionValidated(isValid)
            }}
            onIsLoading={isLoading => {
              onIsLoading && onIsLoading(isLoading)
            }}
            onSelectValidExpression={expression =>
              onChangeInput && onChangeInput('priceExpression', expression)
            }
            onSelectPriceCalculationType={calculationType =>
              onChangeInput && onChangeInput('priceCalculationType', calculationType)
            }
            onSelectPriceUnit={priceUnit =>
              onChangeInput && onChangeInput('precioUnitario', priceUnit)
            }
            onSelectRounding={rounding => onChangeInput && onChangeInput('redondeo', rounding)}
            priceVersion={1}
            activeExpression={price.priceExpression}
            activePriceCalculationType={price.priceCalculationType}
            activePriceUnit={price.precioUnitario}
            activeRounding={price.redondeo}
          />
        )}
      </Paper>
    </Box>
  )
}
